var _timers = {};

export class Timing {
  constructor(name){
    this._name = name;
    this._counterInMs = 0;
    this._timestamp = null;
  }

  static start(name){
    var timer = new Timing(name);
    timer.start();

    _timers[name] = timer;
    return timer;
  }

  static time(name){
    if (_timers[name]) {
      return _timers[name].time();
    }
  }

  static stop(name){
    if (_timers[name]) {
      _timers[name].stop();
    }
  }

  static clear(name){
    if(name !== undefined){
      Timing.stop(name);
      delete _timers[name];
    } else {
      _timers = {};
    }
  }

  // TODO: No difference between pause and stop?
  static pause(name){
    if (_timers[name]) {
      _timers[name].pause();
    }
  }

  static resume(name){
    if (_timers[name]) {
      _timers[name].resume();
    }
  }

  static inspect(name){
    return _timers[name];
  }

  static reset(name){
    this.clear(name);
    this.start(name);
  }

  start(){
    this._timestamp = Date.now();
  }

  stop(){
    if(this.timestamp() != null) {
      const diffInMs = Date.now() - this.timestamp();
      this._counterInMs = this.counterInMs() + diffInMs;
      this._timestamp = null;
    }
  }

  time(){
    this.stop();
    return this.counterInMs() / 1000;
  }

  pause(){
    this.stop();
  }

  resume(){
    this.start();
  }

  counterInMs(){
    return this._counterInMs;
  }

  tickInMs(){
    return this._tickInMs;
  }

  name(){
    return this._name;
  }

  timestamp() {
    return this._timestamp;
  }
}
